/**
 * Balatro-Style Pixel Art Baseball Component
 * True pixel-art shading with dithering patterns, not CSS gradients
 */
export const Baseball = ({ size = 80, spinning = false, className = '' }) => {
  return (
    <div 
      className={`${spinning ? 'ball-spin' : ''} ${className}`}
      style={{ 
        width: size, 
        height: size,
        filter: 'drop-shadow(5px 5px 0px rgba(0,0,0,0.4)) drop-shadow(8px 8px 12px rgba(0,0,0,0.2))'
      }}
      data-testid={spinning ? "spinning-ball" : "baseball"}
    >
      <svg 
        viewBox="0 0 32 32" 
        width={size} 
        height={size}
        style={{ imageRendering: 'pixelated' }}
      >
        {/* Pixel-art baseball with discrete shading bands */}
        
        {/* Shadow layer - darkest ring */}
        <rect x="10" y="28" width="12" height="2" fill="#888888" />
        <rect x="8" y="26" width="2" height="2" fill="#888888" />
        <rect x="22" y="26" width="2" height="2" fill="#888888" />
        
        {/* Main ball body - base white */}
        <circle cx="16" cy="16" r="13" fill="#f0f0f0" />
        
        {/* Dithered shading - bottom right (shadow side) */}
        {/* Dark band */}
        <rect x="20" y="20" width="2" height="2" fill="#d0d0d0" />
        <rect x="22" y="18" width="2" height="2" fill="#d0d0d0" />
        <rect x="24" y="16" width="2" height="2" fill="#d0d0d0" />
        <rect x="22" y="22" width="2" height="2" fill="#c0c0c0" />
        <rect x="20" y="24" width="2" height="2" fill="#c0c0c0" />
        <rect x="18" y="24" width="2" height="2" fill="#d0d0d0" />
        <rect x="24" y="18" width="2" height="2" fill="#c0c0c0" />
        <rect x="24" y="20" width="2" height="2" fill="#b8b8b8" />
        
        {/* Dithered highlight - top left */}
        <rect x="8" y="8" width="2" height="2" fill="#ffffff" />
        <rect x="10" y="6" width="2" height="2" fill="#ffffff" />
        <rect x="12" y="6" width="2" height="2" fill="#ffffff" />
        <rect x="6" y="10" width="2" height="2" fill="#ffffff" />
        <rect x="6" y="12" width="2" height="2" fill="#ffffff" />
        <rect x="10" y="8" width="2" height="2" fill="#fafafa" />
        <rect x="8" y="10" width="2" height="2" fill="#fafafa" />
        
        {/* Checkerboard dither transition zone */}
        <rect x="14" y="22" width="1" height="1" fill="#e0e0e0" />
        <rect x="16" y="22" width="1" height="1" fill="#e0e0e0" />
        <rect x="22" y="14" width="1" height="1" fill="#e0e0e0" />
        <rect x="22" y="16" width="1" height="1" fill="#e0e0e0" />
        
        {/* Left seam - pixel-art curve */}
        <rect x="7" y="8" width="2" height="2" fill="#cc0000" />
        <rect x="5" y="10" width="2" height="2" fill="#cc0000" />
        <rect x="4" y="12" width="2" height="2" fill="#cc0000" />
        <rect x="4" y="14" width="2" height="2" fill="#cc0000" />
        <rect x="4" y="16" width="2" height="2" fill="#cc0000" />
        <rect x="4" y="18" width="2" height="2" fill="#cc0000" />
        <rect x="5" y="20" width="2" height="2" fill="#cc0000" />
        <rect x="7" y="22" width="2" height="2" fill="#cc0000" />
        
        {/* Left stitch marks - pixel style */}
        <rect x="8" y="9" width="3" height="1" fill="#cc0000" />
        <rect x="6" y="12" width="3" height="1" fill="#cc0000" />
        <rect x="6" y="15" width="3" height="1" fill="#cc0000" />
        <rect x="6" y="18" width="3" height="1" fill="#cc0000" />
        <rect x="8" y="21" width="3" height="1" fill="#cc0000" />
        
        {/* Right seam - pixel-art curve */}
        <rect x="23" y="8" width="2" height="2" fill="#cc0000" />
        <rect x="25" y="10" width="2" height="2" fill="#cc0000" />
        <rect x="26" y="12" width="2" height="2" fill="#cc0000" />
        <rect x="26" y="14" width="2" height="2" fill="#cc0000" />
        <rect x="26" y="16" width="2" height="2" fill="#cc0000" />
        <rect x="26" y="18" width="2" height="2" fill="#cc0000" />
        <rect x="25" y="20" width="2" height="2" fill="#cc0000" />
        <rect x="23" y="22" width="2" height="2" fill="#cc0000" />
        
        {/* Right stitch marks - pixel style */}
        <rect x="21" y="9" width="3" height="1" fill="#cc0000" />
        <rect x="23" y="12" width="3" height="1" fill="#cc0000" />
        <rect x="23" y="15" width="3" height="1" fill="#cc0000" />
        <rect x="23" y="18" width="3" height="1" fill="#cc0000" />
        <rect x="21" y="21" width="3" height="1" fill="#cc0000" />
        
        {/* Seam shadow for depth */}
        <rect x="8" y="9" width="1" height="1" fill="#990000" />
        <rect x="6" y="13" width="1" height="1" fill="#990000" />
        <rect x="6" y="16" width="1" height="1" fill="#990000" />
        <rect x="8" y="22" width="1" height="1" fill="#990000" />
        <rect x="23" y="9" width="1" height="1" fill="#990000" />
        <rect x="25" y="13" width="1" height="1" fill="#990000" />
        <rect x="25" y="16" width="1" height="1" fill="#990000" />
        <rect x="23" y="22" width="1" height="1" fill="#990000" />
        
        {/* Black outline - crisp pixel border */}
        <circle cx="16" cy="16" r="14" fill="none" stroke="#1a1a1a" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default Baseball;
